<!-- TODO componente non usato -->
<ng-container *ngIf="block">
    <div class="container-card" [ngStyle]="{'background-color': true ? '' : '#F3F8F6'}">
        <div>
            <p class="ls-label-small-semibold" [ngClass]="true ? 'text-neutral-80' : 'text-neutral-60'">Categoria</p>
        </div>
        <div>
            <h3 class="ls-h3-item-title text-neutral-95">Titolo pagina lorem ipsum dolor su una riga oppure su due righe
            </h3>
            <a [routerLink]="[]">
                <div class="m-0 container-card__cta line-discover-with-icon" style="min-width: 50%;">
                    <p class="ls-label-medium-semibold text-uppercase" [innerHTML]="'scopri di più'"
                        [ngClass]="true ? 'text-neutral-A1' : 'text-brand-40'">
                    </p>
                    <i class="fa-solid fa-arrow-right pb-4" [ngClass]="true ? 'text-neutral-A1' : 'text-brand-40'" aria-hidden="true"></i>
                </div>
            </a>
        </div>
    </div>
</ng-container>